export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS';

export const deleteReportSuccess = (id) => ({
    type: DELETE_REPORT_SUCCESS,
    payload: { id },
});
